/* eslint-disable max-len */

export const loadPagSeguroSDK = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (window.PagSeguro) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = "https://assets.pagseguro.com.br/checkout-sdk-js/rc/dist/browser/pagseguro.min.js";
    script.async = true;
    script.onload = () => {
      if (window.PagSeguro) {
        resolve();
      } else {
        reject(new Error("PagSeguro SDK não carregado corretamente."));
      }
    };
    script.onerror = () => reject(new Error("Erro ao carregar o SDK do PagSeguro."));
    document.body.appendChild(script);
  });
};